import type { IServiceFilters } from '@/types/rc/filters'
import type { IServiceForm } from '@/types/rc/forms'
import type { IService } from '@/types/rc/work-orders'
import axios from 'axios'

/**
 * Gets all repair services.
 *
 * @returns an array of JS objects representing repair services.
 */
export async function getAllServices(filters?: IServiceFilters): Promise<IService[]> {
  const res = await axios.get(import.meta.env.VITE_APP_RC_SERVICES_ENDPOINT, {
    params: filters,
  })
  return res.data
}

/**
 * Delete a service.
 *
 * @param serviceID the service ID
 */
export async function deleteService(serviceID: number) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_SERVICES_ENDPOINT}/${serviceID}`)
  return res.data
}

/**
 * Create a service.
 *
 * @param data service data
 * @throws {AxiosError}
 */
export async function createService(data: IServiceForm): Promise<IService> {
  const res = await axios.post(`${import.meta.env.VITE_APP_RC_SERVICES_ENDPOINT}`, data)
  return res.data
}

/**
 * Update a service by id.
 *
 * @param id service id
 * @param data service update data
 */
export async function updateService(id: number, data: IServiceForm): Promise<IService> {
  const res = await axios.put(`${import.meta.env.VITE_APP_RC_SERVICES_ENDPOINT}/${id}`, data)
  return res.data
}
